<template>
  <div class="sunset-shell">
    <div class="sunset-shell__bg" aria-hidden="true" />
    <header class="sunset-shell__header">
      <router-link to="/" class="sunset-shell__brand" aria-label="Workmorr home">
        <img class="sunset-shell__logo" :src="brandLogo" alt="Workmorr" width="180" height="34" />
      </router-link>
      <router-link to="/" class="sunset-shell__back">← Back to home</router-link>
    </header>
    <main class="sunset-shell__main">
      <slot />
    </main>
    <footer class="sunset-shell__footer">
      <router-link to="/read/1/support/privacy-policy">Privacy Policy</router-link>
      <span class="sunset-shell__dot" aria-hidden="true">·</span>
      <router-link to="/read/2/support/terms-of-use">Terms of Use</router-link>
    </footer>
  </div>
</template>

<script>
import brandLogo from '@/assets/logo.svg'

export default {
  name: 'SunsetPageShell',
  data() {
    return { brandLogo }
  },
}
</script>

<style scoped>
.sunset-shell {
  --bg: #06080a;
  --border: rgba(255, 255, 255, 0.08);
  --text: #f5f7fa;
  --muted: #94a3b8;
  --accent: #008d36;

  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.sunset-shell__bg {
  pointer-events: none;
  position: fixed;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(ellipse 80% 55% at 50% -20%, rgba(0, 141, 54, 0.1), transparent 55%),
    radial-gradient(ellipse 50% 35% at 0% 70%, rgba(0, 141, 54, 0.05), transparent 45%),
    var(--bg);
}

.sunset-shell__header,
.sunset-shell__main,
.sunset-shell__footer {
  position: relative;
  z-index: 1;
}

.sunset-shell__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  max-width: 720px;
  margin: 0 auto;
  padding: 1.25rem 1.5rem 0;
}

.sunset-shell__brand {
  display: inline-flex;
  line-height: 0;
  text-decoration: none;
}

.sunset-shell__logo {
  height: 34px;
  width: auto;
  max-width: min(200px, 52vw);
  display: block;
}

.sunset-shell__back {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--accent);
  text-decoration: none;
}

.sunset-shell__back:hover {
  text-decoration: underline;
}

.sunset-shell__main {
  flex: 1;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 1.5rem 1.5rem 3rem;
  box-sizing: border-box;
}

.sunset-shell__footer {
  margin-top: auto;
  padding: 1.25rem 1.5rem 2rem;
  text-align: center;
  font-size: 0.9rem;
  border-top: 1px solid var(--border);
}

.sunset-shell__footer a {
  color: var(--accent);
  text-decoration: none;
  font-weight: 500;
}

.sunset-shell__footer a:hover {
  text-decoration: underline;
}

.sunset-shell__dot {
  margin: 0 0.35rem;
  color: var(--muted);
}
</style>
